import {
    createSelector,
    createEntityAdapter
} from "@reduxjs/toolkit";
import { apiSlice } from "../../app/api/apiSlice"

const consumableAdapter = createEntityAdapter({})

const initialState = consumableAdapter.getInitialState()

export const consumableApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getconsumables: builder.query({
            query: () => ({
                url: '/consumable',
                validateStatus: (response, result) => {
                    return response.status === 200 && !result.isError
                },
            }),
            transformResponse: responseData => {
                const loadedconsumable = responseData.map(consumable => {
                    // console.log(brandmaster)
                    consumable.id = consumable._id
                    // console.log(brandmaster)
                    return consumable
                });
                return consumableAdapter.setAll(initialState, loadedconsumable)
            },
            providesTags: (result, error, arg) => {
                if (result?.ids) {
                    return [
                        { type: 'CONSUMABLE', id: 'LIST' },
                        ...result.ids.map(id => ({ type: 'CONSUMABLE', id }))
                    ]
                } else return [{ type: 'CONSUMABLE', id: 'LIST' }]
            }
        }),
        addNewconsumable: builder.mutation({
            query: initialUserData => ({
                url: '/consumable',
                method: 'POST',
                body: {
                    ...initialUserData,
                }
            }),
            invalidatesTags: [
                { type: 'CONSUMABLE', id: "LIST" }
            ]
        }),
        updateconsumable: builder.mutation({
            query: initialUserData => ({
                url: '/consumable',
                method: 'PUT',
                body: {
                    ...initialUserData,
                }
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'CONSUMABLE', id: arg.id }
            ]
        }),
        updateflowAddConsumable: builder.mutation({
            query: initialUserData => ({
                url: '/consumable/updateflow',
                method: 'PUT',
                body: {
                    ...initialUserData,
                }
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'CONSUMABLE', id: arg.id }
            ]
        }),        
        deletebconsumable: builder.mutation({
            query: ({ id }) => ({
                url: `/consumable`,
                method: 'DELETE',
                body: { id }
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'CONSUMABLE', id: arg.id }
            ]
        }),
    }),
})

export const {
    useGetconsumablesQuery,
    useAddNewconsumableMutation,
    useUpdateconsumableMutation,
    useUpdateflowAddConsumableMutation,
    useDeletebconsumableMutation
} = consumableApiSlice

// returns the query result object
export const selectconsumableResult = consumableApiSlice.endpoints.getconsumables.select()

// creates memoized selector
const selectconsumableData = createSelector(
    selectconsumableResult,
    consumableResult => consumableResult.data // normalized state object with ids & entities
)

//getSelectors creates these selectors and we rename them with aliases using destructuring
export const {
    selectAll: selectAllconsumcat,
    selectById: selectconsumcatById,
    selectIds: selectconsumcatIds
    // Pass in a selector that returns the users slice of state
} = consumableAdapter.getSelectors(state => selectconsumableData(state) ?? initialState)